<template>
  <!-- Authors Table Card -->
  <a-card
    :bordered="false"
    class="header-solid h-full"
    :bodyStyle="{ padding: '0 20px' }"
  >
    <template #title>
      <a-row type="flex" align="middle">
        <a-col :span="24" :md="12">
          <h5 class="font-semibold m-0">充值记录</h5>
        </a-col>
      </a-row>
    </template>
    <a-table
      :columns="columns"
      :pagination="pagination"
      :data-source="data"
      @change="tableChange"
    >
      <span slot="key" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <div slot="rechargeCount" slot-scope="text, record">
        <span> 充值数量{{ record.rechargeCount }}条 </span>
        <span v-if="record.giveCount && Number(record.giveCount) > 0">
          （含赠送{{ record.giveCount }}条）
        </span>
      </div>

      <div slot="status" slot-scope="text, record">
        <a-tag v-if="record.status === 1" color="green">充值成功</a-tag>
        <a-tag v-else color="red">充值失败</a-tag>
      </div>
    </a-table>
  </a-card>
  <!-- / Authors Table Card -->
</template>

<script>
export default {
  name: "CardAuthorTable",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 3,
    },
    current: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      pagination: {
        showQuickJumper: true,
        showSizeChanger: true,
        total: this.total,
        pageSize: this.pageSize,
        current: this.current,
      },
      // Active button for the "Authors" table's card header radio button group.
      authorsHeaderBtns: "all",
    };
  },
  methods: {
    tableChange(e) {
      this.$emit("tableChange", e);
    },
  },
};
</script>
